/**
 * List of texture reference
 */
const texture = [
    {
        name: "bricks",
        image: "bricks",
        creator: "“Caveman Chuck” Coker",
    }, 
    {
        name: "bark",
        image: "bark",
        creator: "Jacob Gube",
    },    
    {
        name: "checkerboard",
        image: "checkerboard",
        creator: "Indolences",
    },    
    {
        name: "chevron",
        image: "chevron",
        creator: "Melstampz",
    },
    {
        name: "cobblestone",
        image: "cobblestone",
        creator: "Tiling Tom",
    },    
    {
        name: "dirt",
        image: "dirt",
        creator: "Dfass12",
    },    
    {
        name: "duck",
        image: "duck",
        creator: "Francescominciotti",
    },    
    {
        name: "fabric",
        image: "fabric",
        creator: "Calebkimbrough",
    },    
    {
        name: "grass",
        image: "grass",
        creator: "zaphad1",
    },    
    {
        name: "lava",
        image: "lava",
        creator: "zaphad1",
    },    
    {
        name: "leaves",
        image: "leaves",
        creator: "zaphad1",
    },    
    {
        name: "marble",
        image: "marble",
        creator: "JustMeSupport",
    },    
    {
        name: "metal",
        image: "metal",
        creator: "CopperScaleDragon",
    },    
    {
        name: "paint",
        image: "paint",
        creator: "Walmarc04",
    },    
    {
        name: "rug",
        image: "rug",
        creator: "geishaboy500",
    },    
    {
        name: "sand",
        image: "sand",
        creator: "Sitges",
    },    
    {
        name: "stone",
        image: "stone",
        creator: "Webtreats",
    },    
    {
        name: "water",
        image: "water",
        creator: "Grendelkhan",
    },    
    {
        name: "wood",
        image: "wood",
        creator: "Webtreats",
    },    
    
];
 
export default texture;
